import { Icon } from "@iconify/react";
import { REACTIONS } from "../../../data/Reactions";
import { ReactionType } from "../interfaces/types";

type Props = {
  postId?: number | string;
  likes: number;
  commentsCount: number;
  reactions?: Array<{
    type: ReactionType;  // ✅ بدل string
    user: { id: number; name: string; avatarUrl: string | null };
  }>;
};

const PostStats: React.FC<Props> = ({
  postId,
  likes,
  commentsCount,
  reactions = [],
}) => {
  if (likes === 0 && commentsCount === 0) return null;

  // ✅ أعلى 3 reactions types (unique, بدون null)
  const reactionTypes = Array.from(
    new Set(
      reactions
        .map((r) => r.type)
        .filter((t): t is NonNullable<ReactionType> => t !== null)
    )
  ).slice(0, 3);

  // ✅ أعلى 3 users
  const recentUsers = reactions.slice(0, 3);

  // ✅ فتح الـ comments
  const openComments = () => {
    if (!postId) return;

    document
      .querySelector(`[data-post-comments="${postId}"]`)
      ?.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  return (
    <div className="flex items-center justify-between px-1 py-2 text-sm border-b border-gray-100 dark:border-gray-700/50">
      {/* ============ Reactions ============ */}
      <div className="flex items-center gap-2">
        {likes > 0 && (
          <>
            {/* Avatars stack */}
            <div className="flex -space-x-2">
              {recentUsers.map((r, idx) => (
                <div
                  key={idx}
                  className="relative w-5 h-5 rounded-full border-2 border-white dark:border-deepSlate overflow-hidden shadow-sm"
                  title={r.user.name}
                >
                  <img
                    src={
                      r.user.avatarUrl ||
                      `https://ui-avatars.com/api/?name=${encodeURIComponent(
                        r.user.name
                      )}&background=10b981&color=fff&size=32&bold=true`
                    }
                    alt={r.user.name}
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
            </div>

            {/* Count */}
            <span className="text-gray-600 dark:text-gray-400 font-medium text-xs">
              {likes.toLocaleString()}
            </span>

            {/* Reaction icons */}
            {reactionTypes.length > 0 && (
              <div className="flex items-center -space-x-1 ml-1">
                {reactionTypes.map((type, idx) => {
                  const reaction = REACTIONS.find((r) => r.type === type);
                  if (!reaction) return null;

                  return (
                    <div
                      key={idx}
                      className="w-5 h-5 rounded-full bg-white dark:bg-deepSlate flex items-center justify-center"
                      title={reaction.label}
                    >
                      <Icon
                        icon={reaction.icon}
                        className={`w-4 h-4 ${reaction.color}`}
                      />
                    </div>
                  );
                })}
              </div>
            )}
          </>
        )}
      </div>

      {/* ============ Comments ============ */}
      {commentsCount > 0 && (
        <button
          onClick={openComments}
          className="text-gray-600 dark:text-gray-400 text-xs font-medium hover:text-primary transition-colors flex items-center gap-1 cursor-pointer"
        >
          <Icon icon="mdi:message-outline" className="w-4 h-4" />
          {commentsCount.toLocaleString()}{" "}
          {commentsCount === 1 ? "comment" : "comments"}
        </button>
      )}
    </div>
  );
};

export default PostStats;